import React from 'react';
import {
  Table,
  Button,
  Stack,
  Panel,
  Modal,
  Col,
  FlexboxGrid,
  Tooltip,
  IconButton,
  Whisper,
  Pagination,
  TagPicker,
  SelectPicker,
  Checkbox,
  InputNumber
} from 'rsuite';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import ImageIcon from '@rsuite/icons/Image';
import TableCustomizeDetails from '../TableEditDetails/TableCustomizeDetails';
const ProdductListView = ({
  selectedRowIds,
  isLoading,
  noData,
  tableData,
  tableHeight,
  defaultColumns,
  auth,
  isLoading3,
  isLoading2,
  handleDownload,
  columnKeys,
  CustomHeaderCell,
  CustomCell,
  tableMeta,
  page,
  setPage,
  handleChangeLimit,
  openPrnt,
  handleClosePrint,
  options,
  selectedFormat,
  setSelectedFormat,
  setInputNumber,
  setSelectAll,
  setProductName,
  setProductProductId,
  setProductDescription,
  setProductSizeUnit,
  setProductCbm,
  setProductFinishName,
  setProductColorName,
  setProductSellingPrice,
  setProductBuyerSku,
  setProductBuyerName,
  setProductHSNCode,
  setProductMOQ,
  setProductGrossWeight,
  setProductNetWeight,
  setProductPTypeName,
  setProductPCode,
  setProductCategoryName,
  productName,
  openAttri,
  setOpenAttri,
  selectAll,
  label,
  productProductId,
  productDescription,
  productSizeUnit,
  productCbm,
  productFinishName,
  productColorName,
  productSellingPrice,
  productBuyerSku,
  productBuyerName,
  productHSNCode,
  productMOQ,
  productGrossWeight,
  productNetWeight,
  productPTypeName,
  productCategoryName,
  handleCustomAttributesOk,
  openAttri2,
  setOpenAttri2,
  handleCustomAttributesOk2,
  openAttri4,
  setOpenAttri4,
  selectAlll,
  setSelectAlll,
  setProductSize,
  productSize,
  handleCustomAttributesOk3,
  open1,
  handleClose1,
  setColumnKeys,
  setProductPrice,
  productPrice
}) => {
  return (
    <>
      <Panel className="cstm-product-row">
        {selectedRowIds.length > 0 ? (
          <p style={{ marginBottom: '5px', color: 'var(--rs-text-secondary)' }}>{`${
            selectedRowIds.length == 1
              ? ` ${selectedRowIds.length} item selected`
              : ` ${selectedRowIds.length} item selected`
          }`}</p>
        ) : (
          <p style={{ color: 'white', opacity: 0 }}>{'erpdaddy'}</p>
        )}

        <Table
          className="cstm-row"
          virtualized
          wordWrap="break-word"
          shouldUpdateScroll={false}
          loading={isLoading}
          rowHeight={60}
          cellBordered
          data={noData ? [] : tableData}
          height={tableHeight}
          rowKey="id"
          style={{ position: 'sticky' }}
          onRowClick={() => {}}
          bordered
        >
          {defaultColumns
            .filter(column => auth || (column.key !== 'AuthorisedBy' && column.key !== 'AuthDate')) // Hide columns if auth is false
            .map(column => {
              if (columnKeys.includes(column.key)) {
                const { key, label, headerCell, cell, ...rest } = column;
                return (
                  <Table.Column {...rest} key={key} align="center">
                    {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                    {cell || <CustomCell dataKey={key} />}
                  </Table.Column>
                );
              }
              return null;
            })}
        </Table>

        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={['total', '-', 'pager', 'skip']}
            total={tableMeta?.pagination?.total || 0}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
        <Modal backdrop="static" open={openPrnt} onClose={handleClosePrint}>
          <Modal.Header>
            <Modal.Title style={{ marginBottom: '-20px' }}>Print Options</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Format</p>
            <Stack direction="column" alignItems="flex-start">
              <SelectPicker
                data={options}
                value={selectedFormat}
                onChange={setSelectedFormat}
                placeholder="Select an option"
                style={{ width: 224, marginBottom: '10px' }}
                searchable={false}
              />
              {selectedFormat === '6' && (
                <div>
                  <InputNumber
                    placeholder="No. of product per page"
                    onChange={value => setInputNumber(value)}
                  />
                </div>
              )}
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            {selectedFormat !== '1' && (
              <Whisper speaker={<Tooltip>Print</Tooltip>}>
                <IconButton
                  icon={<ImageIcon />}
                  appearance="primary"
                  color="cyan"
                  loading={isLoading3}
                  style={{ marginTop: '-10px' }}
                  onClick={() => handleDownload('Print')}
                />
              </Whisper>
            )}
            <Whisper speaker={<Tooltip>Download</Tooltip>}>
              <IconButton
                icon={<FileDownloadIcon />}
                appearance="primary"
                color="cyan"
                loading={isLoading2}
                style={{ marginTop: '-10px' }}
                onClick={() => handleDownload('Download')}
              />
            </Whisper>
          </Modal.Footer>
        </Modal>

        <Modal open={openAttri} onClose={() => setOpenAttri(false)} backdrop="static">
          <Modal.Header>
            <Modal.Title>Custom Attributes1</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={24}>
                <Checkbox
                  checked={selectAll}
                  onClick={() => {
                    const newSelectAll = !selectAll;
                    setSelectAll(newSelectAll);
                    setProductName(newSelectAll);
                    setProductProductId(newSelectAll);
                    setProductDescription(newSelectAll);
                    setProductSizeUnit(newSelectAll);
                    setProductCbm(newSelectAll);
                    setProductFinishName(newSelectAll);
                    setProductColorName(newSelectAll);
                    setProductSellingPrice(newSelectAll);
                    setProductBuyerSku(newSelectAll);
                    setProductBuyerName(newSelectAll);
                    setProductHSNCode(newSelectAll);
                    setProductMOQ(newSelectAll);
                    setProductGrossWeight(newSelectAll);
                    setProductNetWeight(newSelectAll);
                    setProductPTypeName(newSelectAll);
                    setProductPCode(newSelectAll);
                    setProductCategoryName(newSelectAll);
                  }}
                >
                  Select All
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productName} onClick={() => setProductName(!productName)}>
                  {label[0]?.attributes.ProductName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productProductId}
                  onClick={() => setProductProductId(!productProductId)}
                >
                  {label[0]?.attributes.AliasCode}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productDescription}
                  onClick={() => setProductDescription(!productDescription)}
                >
                  {label[0]?.attributes.Description}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productSizeUnit}
                  onClick={() => setProductSizeUnit(!productSizeUnit)}
                >
                  {label[0]?.attributes.Sizeunit}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productCbm} onClick={() => setProductCbm(!productCbm)}>
                  {label[0]?.attributes.cbm}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productFinishName}
                  onClick={() => setProductFinishName(!productFinishName)}
                >
                  {label[0]?.attributes.finish}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productColorName}
                  onClick={() => setProductColorName(!productColorName)}
                >
                  {label[0]?.attributes.color}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productSellingPrice}
                  onClick={() => setProductSellingPrice(!productSellingPrice)}
                >
                  {label[0]?.attributes.SalePrice}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productBuyerSku}
                  onClick={() => setProductBuyerSku(!productBuyerSku)}
                >
                  {label[0]?.attributes.BuyerSku}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productBuyerName}
                  onClick={() => setProductBuyerName(!productBuyerName)}
                >
                  {label[0]?.attributes.BuyerName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productHSNCode}
                  onClick={() => setProductHSNCode(!productHSNCode)}
                >
                  {label[0]?.attributes.HSN}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productMOQ} onClick={() => setProductMOQ(!productMOQ)}>
                  {label[0]?.attributes.MOQ}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productGrossWeight}
                  onClick={() => setProductGrossWeight(!productGrossWeight)}
                >
                  {label[0]?.attributes.GrossWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productNetWeight}
                  onClick={() => setProductNetWeight(!productNetWeight)}
                >
                  {label[0]?.attributes.NetWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productPTypeName}
                  onClick={() => setProductPTypeName(!productPTypeName)}
                >
                  {label[0]?.attributes.ProductType}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productCategoryName}
                  onClick={() => setProductCategoryName(!productCategoryName)}
                >
                  {label[0]?.attributes.Category}
                </Checkbox>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="primary" color="cyan" onClick={handleCustomAttributesOk}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={openAttri2} onClose={() => setOpenAttri2(false)} backdrop="static">
          <Modal.Header>
            <Modal.Title>Custom Attributes2</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={24}>
                <Checkbox
                  checked={selectAll}
                  onClick={() => {
                    const newSelectAll = !selectAll;
                    setSelectAll(newSelectAll);
                    setProductName(newSelectAll);
                    setProductProductId(newSelectAll);
                    setProductDescription(newSelectAll);
                    setProductSizeUnit(newSelectAll);
                    setProductCbm(newSelectAll);
                    setProductFinishName(newSelectAll);
                    setProductColorName(newSelectAll);
                    setProductSellingPrice(newSelectAll);
                    setProductBuyerSku(newSelectAll);
                    setProductBuyerName(newSelectAll);
                    setProductHSNCode(newSelectAll);
                    setProductMOQ(newSelectAll);
                    setProductGrossWeight(newSelectAll);
                    setProductNetWeight(newSelectAll);
                    setProductPTypeName(newSelectAll);
                    setProductPCode(newSelectAll);
                    setProductCategoryName(newSelectAll);
                  }}
                >
                  Select All
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productName} onClick={() => setProductName(!productName)}>
                  {label[0]?.attributes.ProductName}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productDescription}
                  onClick={() => setProductDescription(!productDescription)}
                >
                  {label[0]?.attributes.Description}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productSizeUnit}
                  onClick={() => setProductSizeUnit(!productSizeUnit)}
                >
                  {label[0]?.attributes.Sizeunit}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productCbm} onClick={() => setProductCbm(!productCbm)}>
                  {label[0]?.attributes.cbm}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productProductId}
                  onClick={() => setProductProductId(!productProductId)}
                >
                  ProductCost
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productFinishName}
                  onClick={() => setProductFinishName(!productFinishName)}
                >
                  {label[0]?.attributes.finish}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productColorName}
                  onClick={() => setProductColorName(!productColorName)}
                >
                  {label[0]?.attributes.color}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productSellingPrice}
                  onClick={() => setProductSellingPrice(!productSellingPrice)}
                >
                  {label[0]?.attributes.SalePrice}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productBuyerSku}
                  onClick={() => setProductBuyerSku(!productBuyerSku)}
                >
                  {label[0]?.attributes.BuyerSku}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productBuyerName}
                  onClick={() => setProductBuyerName(!productBuyerName)}
                >
                  {label[0]?.attributes.BuyerName}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productHSNCode}
                  onClick={() => setProductHSNCode(!productHSNCode)}
                >
                  {label[0]?.attributes.HSN}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productMOQ} onClick={() => setProductMOQ(!productMOQ)}>
                  {label[0]?.attributes.MOQ}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productGrossWeight}
                  onClick={() => setProductGrossWeight(!productGrossWeight)}
                >
                  {label[0]?.attributes.GrossWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productNetWeight}
                  onClick={() => setProductNetWeight(!productNetWeight)}
                >
                  {label[0]?.attributes.NetWgt}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productPTypeName}
                  onClick={() => setProductPTypeName(!productPTypeName)}
                >
                  {label[0]?.attributes.ProductType}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productCategoryName}
                  onClick={() => setProductCategoryName(!productCategoryName)}
                >
                  {label[0]?.attributes.Category}
                </Checkbox>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="primary" color="cyan" onClick={handleCustomAttributesOk2}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={openAttri4} onClose={() => setOpenAttri4(false)} backdrop="static">
          <Modal.Header>
            <Modal.Title>Custom Attributes3</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={24}>
                <Checkbox
                  checked={selectAlll}
                  onClick={() => {
                    // console.log('Status :', selectAlll);
                    const newSelectAll = !selectAlll;
                    setSelectAlll(newSelectAll);
                    setProductProductId(newSelectAll);
                    setProductColorName(newSelectAll);
                    setProductNetWeight(newSelectAll);
                    setProductSize(newSelectAll);
                    setProductPrice(newSelectAll);
                  }}
                >
                  Select All
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productProductId}
                  onClick={() => setProductProductId(!productProductId)}
                >
                  {label[0]?.attributes.AliasCode}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productColorName}
                  onClick={() => setProductColorName(!productColorName)}
                >
                  {label[0]?.attributes.color}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productNetWeight}
                  onClick={() => setProductNetWeight(!productNetWeight)}
                >
                  {label[0]?.attributes.NetWgt}
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productSize} onClick={() => setProductSize(!productSize)}>
                  {'Size'}
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productPrice} onClick={() => setProductPrice(!productPrice)}>
                  {'Price'}
                </Checkbox>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="primary" color="cyan" onClick={handleCustomAttributesOk3}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <TableCustomizeDetails
          {...{ open: open1, handleClose: handleClose1, defaultColumns, columnKeys, setColumnKeys }}
        />
      </Panel>
    </>
  );
};

export default ProdductListView;
